/**
 * The Kruvi Access unlocked package. Keep this in step with the newest released version in
 * `salesforce/sfdx-project.json` → packageAliases; the web app is built and shipped with the
 * platform, so a new package version means a new build here too.
 */
export const PACKAGE_VERSION_ID = '04tRM000000FW4PYAW';

export type Environment = 'production' | 'sandbox';

/** Where an admin installs the package. Sandboxes install from test.salesforce.com. */
export function packageInstallUrl(environment: Environment): string {
  const host = environment === 'sandbox' ? 'test.salesforce.com' : 'login.salesforce.com';
  return `https://${host}/packaging/installPackage.apexp?p0=${PACKAGE_VERSION_ID}`;
}
